const ADJUST_POSTS_COUNT = 'PROFILE_USER_STATS_ADJUST_POSTS_COUNT'
const ADJUST_FOLLOWING_COUNT = 'PROFILE_USER_STATS_ADJUST_FOLLOWING_COUNT'

function adjustFollowingCount(amount) {
  return {
    type: ADJUST_FOLLOWING_COUNT,
    payload: { amount }
  }
}

function adjustPostsCount(amount) {
  return {
    type: ADJUST_POSTS_COUNT,
    payload: { amount }
  }
}

module.exports = {
  ADJUST_FOLLOWING_COUNT,
  ADJUST_POSTS_COUNT,
  adjustFollowingCount,
  adjustPostsCount
}
